import { render, staticRenderFns } from "./ModalSeminar.vue?vue&type=template&id=68f58660&"
import script from "./ModalSeminar.vue?vue&type=script&lang=js&"
export * from "./ModalSeminar.vue?vue&type=script&lang=js&"
import style0 from "./ModalSeminar.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports